module.exports = __webpack_public_path__ + "stylesheets/political-landing_6afba764a32b918ccf4d81ecb56fed59.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing/political-landing.less
// module id = Rpkd
// module chunks = 51